export enum MetaRouteKeysWaremaPlus {
    Default = 'DEFAULT',
    Appointments = 'APPOINTMENTS',
    ProductRegistration = 'PRODUCT_REGISTRATION',
    Devices = 'DEVICES',
    Shop = 'SHOP',
    OrderHistory = 'ORDER_HISTORY',
    Account = 'ACCOUNT',
    Projects = 'PROJECTS',
    Consultations = 'CONSULTATIONS',
}
